var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVectors = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#istock-vectors-icon)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0E0F0F",
  d: "M12.842 4.902V2.44A2.443 2.443 0 0 0 10.402 0H2.44A2.443 2.443 0 0 0 0 2.44v8.677a2.443 2.443 0 0 0 2.44 2.44h3.465c.982 1.867 2.87 3.135 5.033 3.135 3.173 0 5.754-2.722 5.754-6.069 0-2.642-1.611-4.89-3.85-5.72ZM2.44 12.057a.94.94 0 0 1-.94-.94V2.44c0-.518.422-.94.94-.94h7.961a.94.94 0 0 1 .94.94v2.135c-.133-.01-.266-.021-.402-.021-3.173 0-5.754 2.722-5.754 6.069 0 .495.062.973.169 1.434zm8.498 3.135c-2.345 0-4.253-2.05-4.253-4.569s1.908-4.57 4.253-4.57 4.254 2.05 4.254 4.57-1.908 4.57-4.254 4.57Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "istock-vectors-icon"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16.692v16.692H0z"
})))));
export default SvgVectors;